import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { useFormTcfVendor, useI18n } from "../../../../contexts";
import { FormHeadline } from "../../headline";
import { FORM_TCF_VENDOR_FIELD_PURPOSES_COLUMN_NAME_WIDTH, FormLayoutTcfVendor } from "..";
import { Empty, Table, Tag, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
const { Column } = Table;
const FormTcfVendorFieldFeatures = ()=>{
    const { __ } = useI18n();
    const { vendor, declarations: { features, specialFeatures } } = useFormTcfVendor();
    const useFeatures = useMemo(()=>Object.values(features).map((feature)=>vendor.features.indexOf(feature.id) > -1 ? {
                feature,
                isSpecial: false
            } : undefined).concat(Object.values(specialFeatures).map((specialFeature)=>vendor.specialFeatures.indexOf(specialFeature.id) > -1 ? {
                feature: specialFeature,
                isSpecial: true
            } : undefined)).filter(Boolean), [
        vendor,
        features,
        specialFeatures
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FormHeadline, {
                offset: FormLayoutTcfVendor.labelCol.span,
                description: __("Features are specified by the vendor and are immutable. They describe the characteristics of how personal data is processed in order to achieve one or more purposes."),
                children: __("Features and special features")
            }),
            /*#__PURE__*/ _jsxs(Table, {
                locale: {
                    emptyText: /*#__PURE__*/ _jsx(Empty, {
                        description: __("This vendor has not listed any used features.")
                    })
                },
                dataSource: useFeatures,
                rowKey: (param)=>{
                    let { feature: { id }, isSpecial } = param;
                    return `${id}-${isSpecial}`;
                },
                size: "small",
                bordered: true,
                pagination: false,
                style: {
                    marginBottom: 25
                },
                children: [
                    /*#__PURE__*/ _jsx(Column, {
                        width: FORM_TCF_VENDOR_FIELD_PURPOSES_COLUMN_NAME_WIDTH,
                        title: __("Name"),
                        dataIndex: "name",
                        render: (_, param)=>{
                            let { feature: { name } } = param;
                            return name;
                        }
                    }, "name"),
                    /*#__PURE__*/ _jsx(Column, {
                        title: __("Description"),
                        dataIndex: "description",
                        render: (_, param)=>{
                            let { feature: { description, illustrations }, isSpecial } = param;
                            return /*#__PURE__*/ _jsxs(Tooltip, {
                                title: illustrations.length > 0 && /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsxs("strong", {
                                            children: [
                                                __("Illustrations"),
                                                ": "
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("ul", {
                                            children: illustrations.map((illustration)=>/*#__PURE__*/ _jsx("li", {
                                                    children: illustration
                                                }, illustration))
                                        })
                                    ]
                                }),
                                placement: "bottomLeft",
                                overlayInnerStyle: {
                                    width: 500
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(InfoCircleOutlined, {
                                        style: {
                                            cursor: "pointer",
                                            opacity: 0.5
                                        }
                                    }),
                                    "\xa0",
                                    description,
                                    " ",
                                    isSpecial && /*#__PURE__*/ _jsx(Tag, {
                                        color: "warning",
                                        children: __("Special feature")
                                    })
                                ]
                            });
                        }
                    }, "description")
                ]
            })
        ]
    });
};
export { FormTcfVendorFieldFeatures };
